import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import type { AppDispatch, RootState } from "@/store"
import type { Sage300UpsertRequestDto } from "../dtos/Sage300ConnectDto"
import {
  fetchSage300ConnectionThunk,
  upsertSage300ConnectionThunk,
  deleteSage300ConnectionThunk,
  clearSage300ConnectorState,
  selectSage300Connection,
  selectSage300IsLoading,
  selectSage300IsSubmitting,
  selectSage300IsDeleting,
  selectSage300Error,
  selectSage300IsSuccess,
} from "../store/sage300ConnectorSlice"
import { selectCurrentOrganizationId } from "@/modules/organizations/store/organizationSlice"

export function useSage300Connector(autoLoad = true) {
  const dispatch = useDispatch<AppDispatch>()

  const orgId = useSelector((s: RootState) => selectCurrentOrganizationId(s))
  const connection = useSelector((s: RootState) => selectSage300Connection(s))
  const isLoading = useSelector((s: RootState) => selectSage300IsLoading(s))
  const isSubmitting = useSelector((s: RootState) =>
    selectSage300IsSubmitting(s),
  )
  const isDeleting = useSelector((s: RootState) => selectSage300IsDeleting(s))
  const error = useSelector((s: RootState) => selectSage300Error(s))
  const isSuccess = useSelector((s: RootState) => selectSage300IsSuccess(s))

  useEffect(() => {
    if (!autoLoad) return
    dispatch(clearSage300ConnectorState())
    dispatch(fetchSage300ConnectionThunk())
  }, [autoLoad, dispatch, orgId])

  return {
    connection,
    isLoading,
    isSubmitting,
    isDeleting,
    error,
    isSuccess,
    refresh: () => dispatch(fetchSage300ConnectionThunk()),
    upsert: (dto: Sage300UpsertRequestDto) =>
      dispatch(upsertSage300ConnectionThunk(dto)),
    disconnect: () => dispatch(deleteSage300ConnectionThunk()),
  }
}
